
define('ldsh!modules/lp_info/templates/change_url_popup', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-overlay-container">\n  <div class="md__modal__inner__container">\n    <div class="ed-opt-toolbar ed-modal-header">\n      <div class="ed-close-wrapper">\n        <i class="ri-close-line js-close"></i>\n      </div>\n      <h3 data-i18n="landingPage.dialog.url.title" class="ed-modal-title"></h3>\n    </div>\n\n    <div class="ed-opt-content ed-modal-content">\n      <div class="ed-form-group">\n        <label data-i18n="landingPage.dialog.url.currentURL" class="text-block"></label>\n        <input type="text" value="' +
((__t = ( fullUrl )) == null ? '' : __t) +
'" class="ed-form-control is-disabled ed-form-item-full" disabled="" />\n      </div>\n\n      <div class="ed-form-group form-inline">\n        <label data-i18n="landingPage.dialog.url.domain" for="" class="text-block"></label>\n        <div class="flex gap-8 align-center justify-space-between">\n          <select class="ed-form-control js-domain-selector e100">\n            <option value="default">mdirector-pages.com</option>\n            ';
 domains.each(function(domain) { ;
__p += '\n              <option ' +
((__t = (selected(domain) )) == null ? '' : __t) +
' value="' +
((__t = ( domain.id )) == null ? '' : __t) +
'"\n                  ';
 if(!domain.get("is_valid") || !domain.get("is_valid_protocol")) { ;
__p += ' disabled ';
 } ;
__p += '\n                      >' +
((__t = ( domain.get("url") )) == null ? '' : __t) +
'\n                        ';
 if(!domain.get("is_valid") || !domain.get("is_valid_protocol")) {;
__p += '\n                          (' +
((__t = (badDomainText)) == null ? '' : __t) +
')\n                            ';
} ;
__p += '\n              </option>\n              ';
 }) ;
__p += '\n          </select>\n\n          <input type="text" class="ed-form-control js-uri e100" value="' +
((__t = ( path() )) == null ? '' : __t) +
'" />\n        </div>\n      </div>\n\n      <div class="md__checkbox--wrapper mt16 mb16">\n        <input id="strict_transport_security" type="checkbox" class="md__checkbox--primary js-filter-hidden"\n          ' +
((__t = (strictTransportSecurity==='1' && "checked" )) == null ? '' : __t) +
'\n        />\n        <label for="strict_transport_security" data-i18n="landingPage.dialog.url.strictTransportSecurity"></label>\n      </div>\n\n      ';
 if (!domains.length) {;
__p += '\n        <div class="flex align-center justify-space-between gap-24 mt-24">\n          <p class="i18n m0 p0 text-left e100" data-i18n="landingPage.dialog.url.emptyDomains"></p>\n          <button type="button" class="btn--primary--alt js-add-domain no-wrap"\n            data-i18n="landingPage.dialog.url.goDomains"></button>\n        </div>\n        ';
 };
__p += '\n    </div>\n\n    <div class="ed-opt-btnbar ed-modal-footer">\n      <button data-i18n="common.cancelButton" type="button" class="ed-btn ed-btn-secondary-action js-cancel"></button>\n      <button data-i18n="landingPage.dialog.url.okButton" type="button"\n        class="ed-btn ed-btn-primary-action js-ok"></button>\n    </div>\n  </div>\n</div>';

}
return __p
};});

